import ManagerFlightBooking from './ManagerFlightBooking';

export default ManagerFlightBooking;
